import React from 'react';

const RedirectPage = () => {

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <p>Validando datos de sesión, será redirigido automáticamente.</p>
      <p>
        Si no es redirigido automáticamente,{' '}
        <a href="/">haz click aquí</a>.
      </p>
    </div>
  );
};

export default RedirectPage;
